import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import Loader from "../../../components/common/Loader";
import YoutubeSession from "./YoutubeSession";
import Calendar from "../../../components/Calendar/Calendar";
import DashboardMasterclassesList from "./DashboardMasterclassesList";
import {MasterClassService} from "../../../services/masterClassService/masterClassService";
import DashboardAnnouncements from "./DashboardAnnouncements";
import {useNavigate} from "react-router-dom";

const SpeakerDashboard = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [state, setState] = useState({
        loader: false,
    });

    const [masterClasses, setMasterClasses] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        setIsLoading(true);
        getAllMasterClasses();
    }, []);

    const getAllMasterClasses = async () => {
        try {
            const response = await MasterClassService.getSpeakerMasterClasses(1);

            setMasterClasses(response?.data.data);

            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    };

    return (
        <>
            {state?.loader || isLoading ? (
                <Loader />
            ) : (
                <>
                    <div className="container-fluid dashboard-content">
                        <div className="row mb-5">
                            <DashboardAnnouncements />
                            <div className="col-md-6 mb-4 mb-md-0">
                                <h1>Driving Educational Growth with Expert Training</h1>
                                <span className="fs-5 text-second fs-lg-4">
                                   ACTE Masterclass Series provides educational institutions with highly impactful professional development masterclasses featuring influential thought leaders, subject matter experts, and insightful coaching. We ignite a tipping point that advances institutional culture forward faster.
                                </span>
                                <div className="d-flex mt-3">
                                    <a target="_blank" href="https://www.catapultlpd.com/catapult-manifesto">
                                        <button className="btn btn-primary-info py-2 px-3">
                                            Learn More
                                        </button>
                                    </a>
                                </div>
                            </div>

                            <div className="col-md-6 text-center">
                                <div className="master-class__image">
                                    <YoutubeSession video={"https://vimeo.com/1058261946"}/>
                                </div>
                            </div>
                        </div>
                        <div className="single-lesson-grid">
                            <div className="py-3">
                                <DashboardMasterclassesList
                                    masterClasses={masterClasses}
                                />
                            </div>
                            <div className="py-3">
                                <h3>Events</h3>
                                <div className="card-layout-calendar">
                                    <Calendar/>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default SpeakerDashboard;